// Module state, not component state: every step renders its own frame, so the
// carousel remounts on each step. Keeping the position and the prizes already
// reported here lets the rotation carry on where it was and report each prize
// once per page load. A reload starts both over.
let index = 0;
const reported = new Set<string>();

export function carouselIndex(): number {
  return index;
}

export function setCarouselIndex(next: number): void {
  index = next;
}

/** True the first time a prize is claimed in this page load, false after. */
export function claimCarouselItemReported(key: string): boolean {
  if (reported.has(key)) return false;
  reported.add(key);
  return true;
}

/** Test seam: forget the position and the reported prizes. */
export function resetCarouselState(): void {
  index = 0;
  reported.clear();
}
